<template>
  <p class="o-form__help"><slot></slot></p>
</template>

<script>
export default {
  name: 'OFormHelp'
}
</script>
